"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transition = transition;
exports.easing = void 0;

var _styledComponents = require("styled-components");

var easing = 'cubic-bezier(0.4, 0, 0.2, 1)';
exports.easing = easing;

function transition() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
  var timing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '350s';
  return (0, _styledComponents.css)(["transition:", " ", " cubic-bezier(0.4,0,0.2,1);"], type, timing);
}